import gsap, { Linear } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export class Parallax {
    constructor(el, start, end) {
        this.start = start ? start : "top bottom";
        this.end = end ? end : "bottom top";

        gsap.registerPlugin(ScrollTrigger);

        this.el = el;
        this.el && this.init();
    }

    init() {
        this.tl = gsap.timeline({
            scrollTrigger: {
                trigger: this.el,
                start: this.start,
                end: this.end,
                scrub: 1,
            },
            defaults: {
                ease: Linear.easeNone,
            },
        });

        this.tl.to(this.el, {
            "--progress": 1,
        });
    }
}

const parallax = () => {
    const parallaxItems = document.querySelectorAll(".parallax");
    parallaxItems.length > 0 &&
        !window.matchMedia("(prefers-reduced-motion: reduce)").matches &&
        parallaxItems.forEach(item => new Parallax(item));

    const parallaxTopItems = document.querySelectorAll(".parallax-top");
    parallaxTopItems.length > 0 &&
        !window.matchMedia("(prefers-reduced-motion: reduce)").matches &&
        parallaxTopItems.forEach(item => new Parallax(item, "top top", "bottom top"));
};

export default parallax;
